module.exports = __webpack_public_path__ + "img/image_part_002.02e6a8cd.jpg";